export default __webpack_public_path__ + "static/media/hamburger.1d21619a.png";